<template>
	<toolbar-search-view placeholder="Rolle" />
</template>

<script>
	export default {
		
	}
</script>

<style lang="scss" scoped>

</style>
